import React, { useEffect, useState } from 'react';
import { Select } from '@tencent/spaui';
import { get } from 'store/request';

let TreeData: any[] = [];
let HashData = {};

// eslint-disable-next-line react/display-name
export default (props: { value: string; onChange: (data: string) => void; disabled?: boolean }) => {
  const [treeData, setTreeData] = useState(TreeData);
  const [dataHash, setDataHash] = useState<{ [key: string]: any }>(HashData);

  // 一级列表
  const [list1, setList1] = useState('');
  // 二级列表
  const [list2, setList2] = useState(props.value);

  useEffect(() => {
    if (!props.value) {
      return;
    }
    setList1(dataHash[props.value] ? dataHash[props.value].parent_code : '');
    setList2(props.value);
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [dataHash, props.value]);

  useEffect(() => {
    if (TreeData.length !== 0) {
      return;
    }
    get('/meta/area').then((res) => {
      const { departmentHash, tree } = ForMateData(res);
      setTreeData(tree);
      TreeData = tree;
      setDataHash(departmentHash);
      HashData = departmentHash;
    });
  }, []);

  return (
    <div style={{ display: 'flex' }}>
      <Select
        disabled={props.disabled}
        search
        value={list1}
        data={treeData.map((item) => ({ label: item.name, value: item.code }))}
        onChange={(event: EventTarget, value = '') => {
          setList1(value);
          setList2('');
          props.onChange('');
        }}
      />
      <Select
        disabled={props.disabled}
        search
        value={list2}
        data={dataHash[list1]?.children.map((item: any) => ({ label: item.name, value: item.code }))}
        onChange={(event: EventTarget, value = '') => {
          setList2(value);
          props.onChange(value);
        }}
      />
    </div>
  );
};

function ForMateData(data: any[]) {
  const departmentHash: { [key: string | number]: any } = {};
  const tree: any[] = [];
  const orphanList: any[] = [];

  data.forEach(({ code, name, parent_code, status }) => {
    if (status !== 'active') {
      return;
    }

    const item = {
      code,
      name,
      parent_code,
    };

    departmentHash[code] = item;

    const parent = departmentHash[parent_code];
    if (!parent) {
      orphanList.push(item);
      return;
    }

    if (!parent.children) {
      parent.children = [];
    }
    parent.children.push(item);
  });

  orphanList.forEach((item) => {
    const parent = departmentHash[item.parent_code];
    if (!parent) {
      tree.push(item);
      return;
    }

    if (!parent.children) {
      parent.children = [];
    }
    parent.children.push(item);
  });
  return {
    departmentHash,
    tree,
  };
}
